import React, { useState, useEffect, useCallback } from "react";
import "../styles/Acessibilidade.css";

const Acessibilidade = () => {
  const [fontSize, setFontSize] = useState(16); // Tamanho inicial da fonte

  // useCallback evita a recriação da função em cada renderização.
  const aplicarFontesGlobais = useCallback(() => {
    const elementosTexto = document.querySelectorAll(
      "p, h1, h2, h3, h4, h5, h6, span, a, button, input, textarea, label"
    );

    elementosTexto.forEach((el) => {
      el.style.fontSize = `${fontSize}px`;
    });
  }, [fontSize]);

  // useEffect com dependências corretas.
  useEffect(() => {
    aplicarFontesGlobais();
  }, [aplicarFontesGlobais]);

  const aumentarFonte = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 50)); // Limite máximo: 50px
  };

  const diminuirFonte = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 12)); // Limite mínimo: 12px
  };

  return (
    <div className="acessibilidade-container">
      <button
        className="zoom-button"
        onClick={aumentarFonte}
        aria-label="Aumentar fonte"
      >
        A+
      </button>
      <button
        className="zoom-button"
        onClick={diminuirFonte}
        aria-label="Diminuir fonte"
      >
        A-
      </button>
    </div>
  );
};

export default Acessibilidade;
